<template>
<div class="animated fadeIn">
  <b-btn block variant="primary" @click="goCreate">Nuevo <i class="fa fa-plus fa-lg"></i></b-btn>
</div>
</template>
<script>
export default {
  name: 'btnPlus',
  methods: {
    goCreate: function () {
      let last = window.location.hash.split('/')[(window.location.hash.split('/').length) - 1]
      let origin = window.location.origin
      let url = window.location.hash
      let hash = url.slice(0, (url.length - last.length))
      window.location.href = origin + hash + 'create'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/buttons/btnPlus.vue